import React from 'react';

const Privacy = () => {
    return (
        <div>
            <p tabIndex={0}>
                Conversion Logix LLC collects the following personal information categories: Identifiers: name, email
                address, phone number. Internet or other similar network activity: browsing history, search history,
                information on a consumer’s interaction with a website, application, or advertisement.
            </p>
            <p tabIndex={0}>
                Geolocation data: Physical location or movements. We collect this PI for the following business
                purposes: 1. To fulfill or meet the reason you provided the information. For example, if you share your
                name and contact information to request a price quote or ask a question about our products or services,
                we will use that personal information to respond to your inquiry. 2. To personalize your Website
                experience and to deliver content and product and service offerings relevant to your interests,
                including targeted offers and ads through our Website, third-party sites, and via email or text message
                (with your consent, where required by law).
            </p>
            <p tabIndex={0}>
                To view our full privacy policy, visit{' '}
                <a href="https://conversionlogix.com/privacy-policy/" target="_blank" rel="noreferrer">
                    conversionlogix.com/privacy-policy/
                </a>
                .
            </p>
        </div>
    );
};

export default Privacy;
